import * as React from 'react';
import * as _ from 'lodash';
import { connect, ConnectedProps } from 'react-redux';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';
import projectHelper from '../../../../services/ProjectHelper';
import ErrorPanel from '../ErrorPanel/ErrorPanel';
import cancelEvent from '../../../../services/mini/cancelEvent';
import logLevels from '../../../../const/logLevels';
import editorSettings from '../../../../const/editorSettings';
import phraseTypes from '../../../../const/phraseTypes';
import scriptDraftsService from '../../../../services/ScriptDraftService';
import projectLogsKeeper from '../../../../services/dataKeepers/ProjectLogsKeeper';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import capitalize from '../../../../services/mini/capitalize';
import { Environment } from '../../../../const/environment';
import NoScriptsView from '../NoScriptsView/NoScriptsView';
import ScriptIsUnavailableView from '../ScriptIsUnavailableView/ScriptIsUnavailableView';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import {
    PHRASE_FILTER,
    PATTERN_FILTER,
    ENTITY_TYPE_FILTER,
    ENTITY_VALUE_FILTER,
    DIALOG_FILTER,
    OUTPUT_PHRASES,
    INPUT_PHRASES,
    UNRECOGNIZED_PHRASES,
    ENTITIES,
    PATTERNHASH_FILTER
} from '../../../../const/logFilters';
import getCodeMirrorInstance from '../../../../services/mini/getCodeMirrorInstance';
import globalEvents from '../../../../const/globalEvents';
import {
    CHARACTER_LIMIT,
    SCRIPT_SIZE_LIMIT,
} from '../../../../const/limits';
import ToasterService from '../../../../services/ToasterService';
import getStrLengthInUtf8Bytes from '../../../../services/mini/getStrLengthInUtf8Bytes';
import { ScriptsPanelContainer } from '../ScriptsPanelContainer/ScriptsPanelContainer';
import tooltips from '../../../../const/tooltips';
import TileTooltip from '../../../components/TileTooltip/TileTooltip';
import ReactTooltip from 'react-tooltip';
import {
    saveTooltipState,
    shouldShowTooltip,
} from '../../../../services/tooltipService';
import NoExistingScriptView from '../NoExistingScriptView/NoExistingScriptView';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import * as actions from '../../../../redux/codeMetaData/actions.codeMetaData';
import * as projectActions from '../../../../redux/projects/actions.projects';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import { IOpenLargeScriptParam, updateScripts } from '../../../../redux/projects/actions.projects';
import EditorSearch from '../../../components/EditorSearch/EditorSearch';
import { Resizer } from '../../../components/Resizer/Resizer';

import '../../../../services/cm/alanKeywords';
import '../../../../services/cm/comment';
import messages from '../../../../const/messages';
import store from '../../../../store';
import { IScript } from '../../../../models/IScript';
import { ISyntaxError } from '../../../../models/ISyntaxError';
import { ILogFilters } from '../../../../models/ILogFilters';
import { ILog } from '../../../../models/ILog';
import { IProject } from '../../../../models/IProject';
import AlanButtonPopupsEditor from '../AlanButtonPopupsEditor/AlanButtonPopupsEditor';
import { IAlanBtnPopup } from '../../../../models/IAlanBtnPopup';
import { IStore } from '../../../../redux/initialState';
import { ICodeIdentifier } from '../../../../models/ICodeIdentifier';
import { IProjectApiData } from '../../../../models/IProjectApiData';
import CallProjectApiPanel from '../CallProjectApiPanel/CallProjectApiPanel';
import * as unloadPageActions from '../../../../redux/unloadPage/actions.unloadPage';
import { SCRIPT_EDITOR } from '../../../../const/editorNames';
import { setCurrentBrackets } from '../../../../services/mini/setCurrentBrackets';
import isSessionStorageAvailable from '../../../../services/mini/isSessionStorageAvailable';
import { IOpenErrorsEvent } from '../../../../redux/scriptEditor/saga.scriptEditor';
import TransformContainer from '../TransformMode/TransformContainer/TransformContainer';
import { IIntent } from '../../../../models/IIntent';
import { ISendIntentParam } from '../../../../redux/projects/saga.projects';
import InspectTransformPanel from '../InspectTransformPanel/InspectTransformPanel';
import { saveAllClick } from '../ScriptsPanel/scriptPanelUIHelper';
import { ICorpusData } from '../../../../models/ICorpusData';
import routeHistory from '../../../../history';
import { routeInfo } from '../../../../routeInfo';
import CorpusStatusKeeper from '../../../../services/CorpusStatusKeeper';
import { getScriptTextForScriptArea } from '../../../../services/mini/getScriptTextForScriptArea';
import { IHighlightLineParams } from '../../../../redux/scriptEditor/actions.scriptEditor';

require('../../../../../../node_modules/codemirror/addon/edit/closebrackets');
require('../../../../services/cm/customSearch');
require('../../../../services/cm/anyword-hint');
require('../../../../services/cm/show-hint');
require('../../../../services/cm/highlightChangedLines');

const { default: warningSign } = require("../../../../assets/images/warning-sign-border.svg");

const CM_HISTORY_LENGTH = 2000;

const undoCounterService = {
    _count: 0,
    getCount: function () {
        return this._count;
    },
    increment: function () {
        this._count = this._count + 1;
    },
    reset: function () {
        this._count = 0;
    },
};

const CodeMirror = require('../../../../../../node_modules/codemirror/lib/codemirror');

CodeMirror.keyMap.pcDefault["Ctrl-Z"] = undo;
CodeMirror.keyMap.pcDefault["Ctrl-D"] = duplicateLine;
CodeMirror.keyMap.pcDefault["Ctrl-Delete"] = 'deleteLine';
CodeMirror.keyMap.pcDefault["Ctrl-Backspace"] = 'deleteLine';
CodeMirror.keyMap.pcDefault["Tab"] = betterTab;
CodeMirror.keyMap.pcDefault["Shift-Tab"] = customShiftTab;

CodeMirror.keyMap.macDefault["Cmd-Z"] = undo;
CodeMirror.keyMap.macDefault["Cmd-D"] = duplicateLine;
CodeMirror.keyMap.macDefault["Cmd-Delete"] = 'deleteLine';
CodeMirror.keyMap.macDefault["Cmd-Backspace"] = 'deleteLine';
CodeMirror.keyMap.macDefault["Tab"] = betterTab;
CodeMirror.keyMap.macDefault["Shift-Tab"] = customShiftTab;

const scrollLeftPosTrail = '-scroll-left-pos';
const scrollTopPosTrail = '-scroll-top-pos';
const cursorLineTrail = '-cursor-line';
const cursorChTrail = '-cursor-ch';

const CODE_MIRROR_OPTIONS = {
    lineNumbers: true,
    gutters: ["CodeMirror-linenumbers CodeMirror-intent-only-linenumbers"],
    readOnly: false,
    mode: { name: "alanKeywords", json: true, globalVars: true },
    lint: true,
    indentWithTabs: false,
    tabSize: editorSettings.tabSize,
    indentUnit: editorSettings.indentUnit,
    autoCloseBrackets: true,
    autoCloseTags: true,
    maxHighlightLength: 500,
    lineWrapping: false,
    showCursorWhenSelecting: true,
    searchKey: SCRIPT_EDITOR,
    dragDrop: false
};

const CODE_MIRROR_OPTIONS_READ_ONLY = {
    ...CODE_MIRROR_OPTIONS,
    readOnly: true,
};

export const TEXT_TO_SHOW_LENGTH = 20000;


// todo: remove (this.errorPanel as any)


function betterTab(cm) {
    if (cm.somethingSelected()) {
        cm.indentSelection("add");
    } else {
        cm.replaceSelection(cm.getOption("indentWithTabs") ? "\t" :
            Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");
    }
}

function customShiftTab(cm) {
    if (!cm) return;
    cm.execCommand('indentLess');
}

function autoIndent(cm) {
    if (!cm) return;
    var cursor = cm.getCursor();
    cm.execCommand('selectAll');
    cm.execCommand('indentAuto');
    cm.setCursor(cursor);
}

function duplicateLine(cm) {
    if (!cm) return;
    const currentCursor = cm.doc.getCursor();
    const selection = cm.doc.getSelection();
    if (!selection) {
        const lineContent = cm.doc.getLine(currentCursor.line);
        cm.execCommand('goLineEnd');
        cm.execCommand('newlineAndIndent');
        cm.doc.replaceSelection(lineContent);
        cm.doc.setCursor(currentCursor.line + 1, currentCursor.ch);
        autoIndent(cm);
    } else {
        cm.doc.replaceSelection(selection + selection);
        autoIndent(cm);
    }
}


function undo(cm) {
    if (!cm) return;

    if (undoCounterService.getCount() > 0) {
        for (let i = 0; i < undoCounterService.getCount() - 1; i++) {
            cm.undo();
        }
        undoCounterService.reset();
    } else {
        cm.undo();
    }
}

function toggleComment(cm) {
    cm.toggleComment({
        lineComment: '//',
        fullLines: true,
        commentBlankLines: true
    });
}

interface ILineInfo {
    level: number;
    type: number;
    notFound: boolean;
    warning: boolean;
}

interface IBracketToHighlight {
    start: {
        val: string,
        col: number,
        line: number,
        highlight: boolean
    }
    end: {
        val: string,
        col: number,
        line: number,
        highlight: boolean
    }
}

type ScriptAreaProps = PropsFromRedux & {
    script: IScript
    environment: Environment
    project: IProject
    tagId: string
    projectMode: string
    transformMode: boolean
    syntaxErrors: ISyntaxError[]
    bracketsInStrings: object
    hasScripts: boolean,
    scriptName: string,
    projectName: string,
    isScriptSaving: boolean,
    selectedStageTagId: string
    selectedProdTagId: string
};

type ScriptAreaState = {
    scriptText: string | null
    scriptTextCurrent: string
    syntaxErrors: ISyntaxError[]
    filters: ILogFilters
    hiddenFilters: ILogFilters
    hasLoadedLogs: boolean,
    logs: ILog[],
    logsUpdatedTs: number | null,
    highlightingType: string,
    filterUpdateTs: number | null,
    scrolled: boolean,
    cursor: null,
    currentBrackets: any[], //todo: remove any and describe type/interface
    currentMemberHighlights: (ICodeIdentifier[])[],
    bracketsInStringsToHighlight: IBracketToHighlight[],
    showDefinitionNav: boolean
    errorPanelTransitionInProcess: boolean
    selectedPopupEditorKey: string | null
    selectedProjectApi: string | null
    selectedTransform: string | null
    intentIsRunning?: boolean,
    scriptIsUpdating?: boolean,
    codeGeneratorStreamId?: null | string | number;
    isScriptsPanelCollapsed?: boolean;
    autoFillFunctionInfo?: null | {
        lineNumber: number,
        end: {
            line: number,
            column: number,
        }
    }
}
class ScriptArea extends React.Component<ScriptAreaProps, ScriptAreaState> {

    cursor = null;
    generateCodeStremId = null;
    checkedScripts = {};

    marks = [];
    // @ts-ignore
    _changesWorker = new Worker(new URL('../../../../workers/script-comparer', import.meta.url));

    prevHighlightedLogs = [];
    isScriptSaving = false;
    filterFromLsApplied = false;
    history = [];

    editor = React.createRef<typeof CodeMirror>();
    container = React.createRef<HTMLDivElement>();
    errorPanel = React.createRef<Resizer>();

    constructor(props) {
        super(props);

        this.state = {
            highlightingType: null,
            // in this component we use uncontrolled version of the React Codemirror
            // this is why we need to change state.scriptText and state.scriptTextCurrent carefully
            // to prevent unneeded re-renders and setting history ("ctr+z works from 3d times bug")
            scriptText: null,
            scriptTextCurrent: null,
            syntaxErrors: [],
            filters: this.getFiltersState(),
            hiddenFilters: {
                syntaxErrors: false,
                runtimeErrors: true,
                info: true,
                inFile: false,
                inputPhrases: false,
                outputPhrases: false,
                unrecognizedPhrases: false,
            } as ILogFilters,
            hasLoadedLogs: false,
            logs: [],
            logsUpdatedTs: null,
            filterUpdateTs: null,
            scrolled: false,
            cursor: null,
            currentBrackets: [],
            currentMemberHighlights: [],
            bracketsInStringsToHighlight: [],
            showDefinitionNav: true,
            errorPanelTransitionInProcess: false,
            selectedPopupEditorKey: null,
            selectedProjectApi: null,
            selectedTransform: null,
        };

        if (!this._changesWorker) {
            throw new Error('failed to create worker');
        }

        this._changesWorker.addEventListener('message', this.changesWorkerMessageListener, false);


    }

    componentDidMount() {
        window.addEventListener('streamContentUpdate', this.updateCodeFromStream, false);
        window.addEventListener('updateLogs', this.updateLogs, false);
        window.addEventListener('updateScripGutter', this.updateScripGutter, false);
        window.addEventListener('clearUnsavedScriptMarkers', this.clearUnsavedScriptMarkers, false);
        window.addEventListener('keydown', this.onSaveHotKeyCb, false);
        window.addEventListener(globalEvents.OPEN_ERRORS, this.openErrorsInErrorPanel.bind(this), false);

        const logs = projectLogsKeeper.getLogs();
        this.setState({ hasLoadedLogs: logs?.length > 0, logs: logs || [] });

        this.autoScrollCm();
        this.highlightLinesWithIcons();
        this.scrollToHighlightedLine();
        this.addHotKeys();
        this.setFiltersState();
        if (!this.isFileTooLarge(this.state.scriptText)) {
            this.props.onCodeChange({ codeString: this.state.scriptText, fileName: this.props.script?.name });
        }
        window.addEventListener('keydown', this.onSearchKeyDown);

        const { script, environment, } = this.props;

        getScriptTextForScriptArea(environment, script).then(scriptText => {
            this.setState({
                scriptText: script ? scriptText : null,
                scriptTextCurrent: script ? scriptText : null,
            }, () => {
                this.autoScrollCm();
            })
        });
    }

    getStringLines = () => {
        return [
            ...this.props.strings,
            ...Array.from(this.props.playStrings),
            ...Array.from(this.props.patternStrings),
        ];
    }

    closeSearch = () => {
        const cm = this.getScriptEditorCm();
        if (cm) {
            cm.execCommand('closeSearch');
        }
    }

    onSearchKeyDown = (e) => {
        // todo: this is temp fix - for future we need to use PopupService here
        if (document.querySelectorAll('.popup-form')?.length > 0) {
            return;
        }
        const cm = this.getScriptEditorCm();
        if (cm) {
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.which === 70) {
                e.preventDefault();
                cm.execCommand('replace');
            } else if ((e.ctrlKey || e.metaKey) && e.which === 70) {
                e.preventDefault();
                cm.execCommand('findPersistent');
            } else if (e.which === 27) {
                cm.execCommand('closeSearch');
            } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.which === 71) {
                e.preventDefault();
                if (!e.target.parentNode?.parentNode?.classList?.contains('CodeMirror')) {
                    cm.execCommand('findPrev');
                }
            } else if ((e.ctrlKey || e.metaKey) && e.which === 71) {
                e.preventDefault();
                if (!e.target.parentNode?.parentNode?.classList?.contains('CodeMirror')) {
                    cm.execCommand('findNext');
                }
            }
        }
    };

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onSaveHotKeyCb, false);
        window.removeEventListener('updateScripGutter', this.updateScripGutter, false);
        window.removeEventListener('updateLogs', this.updateLogs, false);
        window.removeEventListener('clearUnsavedScriptMarkers', this.clearUnsavedScriptMarkers, false);
        window.removeEventListener(globalEvents.OPEN_ERRORS, this.openErrorsInErrorPanel.bind(this), false);


        this._changesWorker.removeEventListener('message', this.changesWorkerMessageListener, false);
        this._changesWorker.terminate();
        delete this._changesWorker;

        this.checkedScripts = {};
        // projectLogsKeeper.clear();
        window.removeEventListener('keydown', this.onSearchKeyDown);

        const { updateUnloadPageListenerForProject } = this.props;
        updateUnloadPageListenerForProject({ hasListener: false });
    }

    componentDidUpdate(prevProps: ScriptAreaProps, prevState: ScriptAreaState) {
        const { script, project, highlightedLine, environment, updateUnloadPageListenerForProject, transformMode } = this.props;
        const { filters } = this.state;

        // console.info('FILTERS', filters);

        if (process.env.NODE_ENV === 'production') {
            projectHelper.hasUnsavedChanges(project).then(hasChanges => {
                if (hasChanges) {
                    updateUnloadPageListenerForProject({ hasListener: true });
                } else {
                    updateUnloadPageListenerForProject({ hasListener: false });
                }
            })
        }

        if (transformMode) return;

        if (this.state.scriptText === null ||
            (prevProps?.project.updateTs !== project.updateTs) ||
            (prevProps?.project.discardScriptsChangesTs !== project.discardScriptsChangesTs) ||
            (prevProps?.project.updateTsAfterMerge !== project.updateTsAfterMerge) ||
            (prevProps?.project.updateTsAfterCiCdSync !== project.updateTsAfterCiCdSync) ||
            (prevProps?.environment !== environment)) {

            getScriptTextForScriptArea(environment, script).then(scriptContent => {
                const changesWereDiscarded = prevProps.project.discardScriptsChangesTs !== project.discardScriptsChangesTs;
                const changesAfterMerge = prevProps.project.updateTsAfterMerge !== project.updateTsAfterMerge;
                const changesAfterCiCdSync = prevProps.project.updateTsAfterCiCdSync !== project.updateTsAfterCiCdSync;
                const hasChanges = this.state.scriptText !== scriptContent || this.state.scriptTextCurrent !== scriptContent || changesWereDiscarded || changesAfterMerge || changesAfterCiCdSync;
                if (hasChanges || this.state.scriptText === null) {

                    if (!this.state.scriptText) {
                        this.setState({ scriptText: scriptContent });
                    } else if (changesWereDiscarded || changesAfterMerge || changesAfterCiCdSync) {
                        if (changesAfterCiCdSync) {
                            this.updateTextInCm(script.text);
                        } else {
                            this.updateTextInCm(scriptContent);
                        }
                    }

                    if (!this.isFileTooLarge(scriptContent)) {
                        this.props.onCodeChange({ codeString: scriptContent, fileName: this.props.script?.name });
                        this.addHighlightingChangesMode();
                        this.addHotKeys();
                        _.defer(() => {
                            this.highlightLinesWithIcons();
                            this.autoScrollCm();
                        }, 0);
                    }
                }
            })


        } else {
            _.defer(() => {
                this.scrollToHighlightedLine();
            });
        }
        if (
            (prevProps.script && script && prevProps.script.name !== script.name && filters.inFile) ||
            prevState.filters[PHRASE_FILTER] !== filters[PHRASE_FILTER] ||
            JSON.stringify(prevState.filters[ENTITIES]) !== JSON.stringify(filters[ENTITIES]) ||
            prevState.filters[PATTERN_FILTER] !== filters[PATTERN_FILTER] ||
            prevState.filters[PATTERNHASH_FILTER] !== filters[PATTERNHASH_FILTER] ||
            prevState.filters[DIALOG_FILTER] !== filters[DIALOG_FILTER]
        ) {
            projectLogsKeeper.clear();
            this.setState({ hasLoadedLogs: false, logs: [], logsUpdatedTs: Date.now(), filterUpdateTs: Date.now() });
        }

        if (prevProps.script && script && prevProps.script.name !== script.name) {
            this.highlightSyntaxErrors();
        }

        this.setFiltersState();

        if ((this.state.scriptText || this.state.scriptText === '') && (!prevState.scriptText && prevState.scriptText !== '')) {
            this.addHotKeys();
            this.checkForLinesChanges(this.state.scriptText);
            if (this.props.showSearch) {
                const cm = this.getScriptEditorCm();
                if (!cm) return;
                if (this.props.showReplace) {
                    cm.execCommand('replace');
                } else {
                    cm.execCommand('findPersistent');
                }
            }
            this.highlightSyntaxErrors();
        }

        if (
            this.state.currentBrackets !== prevState.currentBrackets
            || this.state.currentMemberHighlights !== prevState.currentMemberHighlights
            || this.props.projectApis !== prevProps.projectApis
            || this.props.corpuses !== prevProps.corpuses
            || this.props.intents !== prevProps.intents
            || this.props.transforms !== prevProps.transforms
            || this.props.alanBtnPopups !== prevProps.alanBtnPopups
        ) {
            this.renderMarks();
            this.highlightLinesWithIcons();
        }

        if (prevProps.syntaxErrors !== this.props.syntaxErrors) {
            this.onErrorsChange(this.props.syntaxErrors);
        }
    }

    renderMarks() {
        const cm = this.getScriptEditorCm();
        if (cm) {
            cm.operation(() => {
                if (this.marks) {
                    this.marks.forEach(mark => mark.clear());
                }
                this.marks = [];
                if (this.state.currentMemberHighlights) {
                    this.state.currentMemberHighlights.forEach(highlights => {
                        if (highlights.length > 1) {
                            highlights.forEach(highlight => {
                                this.marks.push(cm.doc.markText(
                                    { line: highlight.loc.start.line - 1, ch: highlight.loc.start.column },
                                    { line: highlight.loc.end.line - 1, ch: highlight.loc.end.column },
                                    { className: 'cm-member-highlight' },
                                ));
                            });
                        }
                    });
                }
                if (this.state.currentBrackets) {
                    this.state.currentBrackets.forEach((bracketGroup: string) => {
                        const [parsedLine, parsedCh] = bracketGroup.split('.');
                        const line = parseInt(parsedLine);
                        const ch = parseInt(parsedCh);
                        this.marks.push(cm.doc.markText(
                            { line: line - 1, ch },
                            { line: line - 1, ch: ch + 1 },
                            { className: 'cm-active-bracket' },
                        ));
                    });
                }
                if (this.state.bracketsInStringsToHighlight) {
                    this.state.bracketsInStringsToHighlight.forEach((bracketData, index) => {
                        this.marks.push(cm.doc.markText(
                            { line: bracketData.start.line - 1, ch: bracketData.start.col },
                            { line: bracketData.start.line - 1, ch: bracketData.start.col + 1 },
                            { className: `cm-active-bracket-${index < 9 ? index : 'common'}` },
                        ));
                        this.marks.push(cm.doc.markText(
                            { line: bracketData.end.line - 1, ch: bracketData.end.col },
                            { line: bracketData.end.line - 1, ch: bracketData.end.col + 1 },
                            { className: `cm-active-bracket-${index < 9 ? index : 'common'}` },
                        ));
                    });
                }
                if (this.props.invalidBrackets) {
                    this.props.invalidBrackets.forEach(bracket => {
                        this.marks.push(cm.doc.markText(
                            { line: bracket.line - 1, ch: bracket.column },
                            { line: bracket.line - 1, ch: bracket.column + 1 },
                            { className: 'cm-invalid-bracket' },
                        ));
                    });
                }
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const curProps = this.props;

        if (curProps.project.scripts.length !== nextProps.project.scripts.length) {
            this.checkForErrors(nextProps.project, true);
        } else {
            this.delayedCheckForErrors(nextProps.project);
        }

        if ((curProps.script && nextProps.script &&
            curProps.script.name !== nextProps.script.name) ||
            (curProps.tagId !== nextProps.tagId) ||
            (curProps.script && nextProps.script &&
                curProps.script.scriptId !== nextProps.script.scriptId)) {
            this.resetPhraseFilter();
            this.setState({ scriptText: null });
            this.props.resetCodeData();
            this.prevHighlightedLogs = [];
        }

        if (this.isScriptSaving && curProps.project.isScriptSaving && !nextProps.project.isScriptSaving) {
            this.isScriptSaving = false;
        }

        if (this.props.environment !== nextProps.environment ||
            this.props.project[`${this.props.environment}TagId`] !== nextProps.project[`${nextProps.environment}TagId`]) {
            this.setState({
                filters: {
                    ...this.state.filters,
                    lastTs: 0
                },
                logs: []
            });
        }
    }

    setFiltersState = () => {
        const { project } = this.props;

        if (!this.filterFromLsApplied && project.projectId) {
            this.filterFromLsApplied = true;
            this.setState({ filters: this.getFiltersState(), filterUpdateTs: Date.now() });
        }
    }

    saveFiltersState = () => {
        const { project } = this.props;
        const { filters } = this.state;

        if (isLocalStorageAvailable()) {
            localStorage.setItem(`alan-project-filters-${project.projectId}`, JSON.stringify({ ...filters, lastTs: 0 }));
        }
    }

    getFiltersState = () => {
        const { project } = this.props;
        let filters = null;
        const defaultFilters = {
            syntaxErrors: false,
            runtimeErrors: true,
            info: true,
            inFile: false,
            [INPUT_PHRASES]: false,
            [OUTPUT_PHRASES]: false,
            [UNRECOGNIZED_PHRASES]: false,
            phraseLineNumber: '',
            currentDialog: false,
            [PHRASE_FILTER]: null,
            [PATTERN_FILTER]: null,
            [DIALOG_FILTER]: null,
            [ENTITIES]: [],
        };

        if (isLocalStorageAvailable() && project.projectId) {
            try {
                filters = JSON.parse(localStorage.getItem(`alan-project-filters-${project.projectId}`));
            } catch (e) {

            }
        }

        return filters || defaultFilters;
    }

    goBackInHistory = () => {
        if (!this.history.length) {
            return;
        }
        const prev = this.history.pop();
        this.scrollToLine(prev.line + 1);
    };

    addHotKeys() {
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        scriptEditor.setOption('extraKeys', {
            'Ctrl-Space': 'autocomplete',
            'Cmd-Alt-L': autoIndent,
            'Ctrl-Alt-L': autoIndent,
            'Cmd-Backspace': 'deleteLine',
            'Ctrl-Backspace': 'deleteLine',
            'Ctrl-Delete': 'deleteLine',
            'Cmd-Delete': 'deleteLine',
            'Cmd-/': toggleComment,
            'Ctrl-/': toggleComment,
            'Cmd-F': 'findPersistent',
            'Ctrl-F': 'findPersistent',
            'Cmd-D': duplicateLine,
            'Ctrl-D': duplicateLine,
            'Cmd-Z': undo,
            'Ctrl-Z': undo,
            'Tab': betterTab,
            'Shift-Backspace': this.goBackInHistory,
        });
        scriptEditor.setOption('undoDepth', () => {
            return CM_HISTORY_LENGTH;
        });

        scriptEditor.setOption('configureMouse', (cm, repeat, event) => {
            const isControl = event.ctrlKey || event.metaKey;
            if (event.altKey && event.shiftKey && !isControl) {
                return { addNew: true };
            } else if (isControl && !event.shiftKey && !event.altKey) {
                return { addNew: false };
            }
            return { addNew: false };
        });
        this.addHighlightingChangesMode();

        scriptEditor.off('onDefClick', this.goToDefinition);
        scriptEditor.on('onDefClick', this.goToDefinition);
    }

    goToDefinition = ({ isVariable, name, partialMatch }) => {
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;

        if (isVariable) {
            if (shouldShowTooltip(tooltips.definitionNav)) {
                ReactTooltip.show(document.getElementById(tooltips.definitionNav));
            }
            const cursor = scriptEditor.getCursor();
            scriptEditor.setSelection(cursor, cursor); // Clear the selection
            scriptEditor.setCursor(cursor);
            setTimeout(() => {
                this.scrollToDefinition(name, partialMatch);
            }, 100);
        }
    }

    updateTextInCm(text) {
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        scriptEditor.operation(() => {
            scriptEditor.setValue(text);
            this.autoScrollCm();
        });
    }

    scrollToDefinition(name, partialMatch?) {
        const { declarationIndex, imports, project } = this.props;

        let defName = partialMatch ? name.split('.')[0] : name;
        let definition;

        if (partialMatch) {
            for (let [key, value] of declarationIndex) {
                if (key.startsWith(`${defName}.`)) {
                    definition = value;
                    break;
                }
            }
        } else {
            definition = declarationIndex.get(defName);
        }

        if (definition) {
            this.history.push({ ...this.cursor });
            this.scrollToWord(definition.loc);
            return true;
        }

        let destFileName;

        defName = name.split('.')[0];

        for (let [key, value] of imports) {
            if (key.startsWith(`${defName}.`)) {
                destFileName = value.source;
                this.highlightLine({
                    project,
                    scriptName: destFileName,
                    lineNumber: 0,
                    character: 0,
                    definitionName: defName
                });
                break;
            }
        }
    }

    onErrorsChange = (errors) => {
        this.updateErrors(errors, () => {
            this.highlightSyntaxErrors();
            setTimeout(() => {
                this.highlightSyntaxErrors();
            }, 100);
        });
    };

    changesWorkerMessageListener = (e) => {
        if (e.data.msg === 'diffResult') {
            const scriptEditor = this.getScriptEditorCm();
            if (!scriptEditor) return;
            CodeMirror.signal(scriptEditor, 'highlightChanges', scriptEditor, e.data.linesInfo);
        }
    }

    addHighlightingChangesMode = () => {
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        scriptEditor.setOption('highlightChangedLines', {});
    }

    sendSavedTextToCodeMirror(scriptText, script, loadChanges) {
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        CodeMirror.signal(scriptEditor, 'saveContent', scriptEditor, scriptText);
    }

    autoScrollCm() {
        const { project, highlightedLine } = this.props;
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        const scriptKey = this.getScriptKey(true);

        if (highlightedLine) {
            _.defer(() => { this.scrollToHighlightedLine(); })
            return;
        }


        if (isLocalStorageAvailable()) {
            const scrollToObj = {
                x: +localStorage.getItem(`${scriptKey}${scrollLeftPosTrail}`) || 0,
                y: +localStorage.getItem(`${scriptKey}${scrollTopPosTrail}`) || 0
            };

            const cursorObj = {
                line: +localStorage.getItem(`${scriptKey}${cursorLineTrail}`) || 0,
                ch: +localStorage.getItem(`${scriptKey}${cursorChTrail}`) || 0
            };

            scriptEditor.setCursor(cursorObj.line, cursorObj.ch);
            scriptEditor.scrollTo(scrollToObj.x, scrollToObj.y);

            const shouldFocus = (document.activeElement?.parentNode?.parentNode as HTMLElement).classList?.contains('CodeMirror');

            if (project && project.projectId && !project.tryMessage && shouldFocus) {
                scriptEditor.focus();
            }
        }
    }

    scrollToHighlightedLine() {
        const {
            highlightedLine,
            highlightedLineType,
            highlightedLineOffset,
            highlightedDefinitionName,
            isParsingInProcess,
            resetHighlighting
        } = this.props;

        let line;

        if (highlightedDefinitionName && isParsingInProcess === false) {
            resetHighlighting();
            this.goToDefinition({
                isVariable: true,
                name: highlightedDefinitionName,
                partialMatch: true
            });
            return;
        }

        if (highlightedLine) {
            line = this.getCmLine(highlightedLine);
            const scriptEditor = this.getScriptEditorCm();
            let yPos;

            if (scriptEditor) {
                scriptEditor.setSelection({ line: line, ch: 0 }, { line: line });
                scriptEditor.scrollIntoView({ line: line });
                var lineTop = scriptEditor.charCoords({ line: line, ch: 0 }, "local").top;
                const offset = scriptEditor.getScrollerElement().offsetHeight - 30;
                if (highlightedLineOffset) {
                    let yPos = lineTop;
                    yPos = lineTop;


                    if (highlightedLineOffset < offset) {
                        yPos = yPos - highlightedLineOffset;
                    } else {
                        yPos = yPos - 100;
                    }
                    scriptEditor.scrollTo(0, yPos);
                } else {
                    scriptEditor.scrollTo(0, lineTop);
                }

            }

            this.rememberCmScrollPosition(scriptEditor, { top: yPos || lineTop, left: 0 });
            resetHighlighting();
            this.setState({ highlightingType: highlightedLineType });
        }
    }

    scrollToLine = (line, endLine?) => {
        this.scrollToWord({
            start: {
                line: line,
            },
            end: {
                line: endLine || line,
            },
        });
    };

    scrollToWord(loc) {
        let line = loc.start.line;
        let endLine = loc.end.line;

        if (!line) {
            return;
        }
        if (endLine) {
            endLine--;
        }
        line--;
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        const cursor = scriptEditor.getCursor();
        scriptEditor.setSelection(cursor, cursor);
        setTimeout(() => {
            const lineTop = scriptEditor.charCoords({ line: Math.max(line - 5, 0), ch: 0 }, 'local').top;
            const endLineTop = scriptEditor.charCoords({ line: Math.max(endLine - 5, 0), ch: 0 }, 'local').top;
            const scrollBottom = scriptEditor.doc.scrollTop + scriptEditor.display.lastWrapHeight;
            if (
                lineTop < scriptEditor.doc.scrollTop || lineTop > scrollBottom || (endLineTop > scrollBottom)
            ) {
                scriptEditor.scrollIntoView({
                    line: Math.max(line - 5, 0),
                    ch: loc.start.column || 0,
                });
                scriptEditor.scrollTo(0, lineTop);
            }
            scriptEditor.setSelection({
                line: endLine,
                ch: loc.end.column || undefined,
            }, {
                line,
                ch: loc.start.column || 0,
            });
        });
    }

    updateSearch = _.debounce(() => {
        const cm = this.getScriptEditorCm();
        if (cm) {
            cm.execCommand('searchTextUpdate');
        }
    }, 250);

    highlightSyntaxErrors() {
        const errUniqLines = {};
        var t = `
        

        `;
        const warnUniqLines = {};
        let tempLineNumber = 1;
        const syntaxErrors = this.state.syntaxErrors;
        const { script } = this.props;

        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;

        if (syntaxErrors && syntaxErrors.length) {
            for (let i = 0; i < syntaxErrors.length; i++) {
                if (syntaxErrors[i].file === script.name) {
                    errUniqLines[syntaxErrors[i].line] = true;
                    if (syntaxErrors[i].isWarning) {
                        warnUniqLines[syntaxErrors[i].line] = true;
                    }
                }
            }
        }
        scriptEditor.operation(() => {
            scriptEditor.eachLine((cmLine) => {
                if (!errUniqLines[tempLineNumber]) {
                    if (cmLine.gutterClass) {
                        scriptEditor.removeLineClass(cmLine, 'gutter', 'script-area-err-line');
                        scriptEditor.removeLineClass(cmLine, 'gutter', 'script-area-log-level-4');
                    }

                    if (cmLine.wrapClass) {
                        scriptEditor.removeLineClass(cmLine, 'wrap', 'script-area-err-line');
                    }
                } else {
                    scriptEditor.addLineClass(cmLine, 'wrap', 'script-area-err-line');
                    scriptEditor.addLineClass(cmLine, 'gutter', 'script-area-err-line');
                    scriptEditor.addLineClass(cmLine, 'gutter', 'script-area-log-level-4');
                }
                if (!warnUniqLines[tempLineNumber]) {
                    if (cmLine.gutterClass) {
                        scriptEditor.removeLineClass(cmLine, 'gutter', 'script-area-warn-line');
                    }

                    if (cmLine.wrapClass) {
                        scriptEditor.removeLineClass(cmLine, 'wrap', 'script-area-warn-line');
                    }
                } else {
                    scriptEditor.addLineClass(cmLine, 'wrap', 'script-area-warn-line');
                    scriptEditor.addLineClass(cmLine, 'gutter', 'script-area-warn-line');
                }

                tempLineNumber++;
            });
        });
    }

    getScriptEditorCm = () => {
        return getCodeMirrorInstance(this.editor.current);
    }

    stopCodeGeneration = () => {
        this.generateCodeStremId = null;
        this.setState({ scriptIsUpdating: false, codeGeneratorStreamId: null });
        const cm = this.getScriptEditorCm();

        if (cm) {
            if (undoCounterService.getCount() > 0) {
                for (let i = 0; i < undoCounterService.getCount(); i++) {
                    cm.undo();
                }
                undoCounterService.reset();
            }
        }
    }

    hasFilterByPhrases() {
        const { filters } = this.state;

        return !!filters[PHRASE_FILTER] || !!filters[PATTERN_FILTER] || !!filters[DIALOG_FILTER] || filters.entities.length > 0;
    }

    updateScripGutter = (e) => {
        if (e && e.type === 'updateScripGutter') {
            this.highlightLinesWithIcons();
        }
    }

    updateLogs = (e) => {
        const currentLogs = this.state.logs;
        let messages;

        if (e && e.type === 'updateLogs') {
            messages = projectLogsKeeper.getLogs();

            if (e.detail.forceUpdate || this.state.filterUpdateTs === e.detail.filterUpdateTs) {
                this.setState({
                    logs: messages,
                    logsUpdatedTs: Date.now(),
                    hasLoadedLogs: true
                });
            }
        }
        if (!window.alanUi.micActive) {
            this.highlightLinesWithIcons();
        }
    }

    updateCodeFromStream = (e) => {
        if (e && e.type === 'streamContentUpdate') {

            if (this.state.codeGeneratorStreamId === e.detail?.streamId) {
                if (e.detail?.final) {
                    this.setState({ scriptIsUpdating: false, codeGeneratorStreamId: null });
                } else {
                    var cm = this.getScriptEditorCm();

                    var pos = {
                        line: this.cursor?.line,
                        ch: this.cursor?.ch
                    };
                    if (cm) {
                        cm.replaceRange(e.detail?.text || '', pos);
                        undoCounterService.increment();
                    }
                }
            }
        }
    }



    clearLogs = (e) => {
        const curFilters = { ...this.state.filters };
        const curLogs = this.state.logs;

        if (curLogs.length > 0) {
            curFilters.lastTs = Date.now();
        }

        if (isSessionStorageAvailable()) {
            sessionStorage.setItem(`alan-logs-last-ts-${this.props.project.projectId}`, Date.now().toString());
        }

        projectLogsKeeper.clear();

        this.setState({ logs: [], logsUpdatedTs: Date.now(), filters: curFilters });

        _.defer(() => {
            this.highlightLinesWithIcons();
        }, 0);

        cancelEvent(e);
    }

    highlightLine = (param: IHighlightLineParams) => {
        this.props.highlightLine({
            project: this.props.project,
            ...param
        });
    }

    onAlanBtnPopupsDataSaved = (scriptText) => {
        this.updateTextInCm(scriptText);
    }

    closePopupEditor = () => {
        this.setState({ selectedPopupEditorKey: null });
    }

    closeProjectApiRunner = () => {
        this.setState({ selectedProjectApi: null });
    }

    closeTransformInspector = () => {
        this.setState({ selectedTransform: null });
    }

    selectProjectApi = (selectedProjectApi) => {
        this.setState({ selectedProjectApi });
    }

    setFilter = (filterName, filterValue?, e?) => {
        const curFilters = _.cloneDeep(this.state.filters);
        const opened = (this.errorPanel as any).current?.resizer.current?.state.isOpened;
        const filters = ['runtimeErrors', 'info', INPUT_PHRASES, OUTPUT_PHRASES, UNRECOGNIZED_PHRASES];
        let activeFiltersCount = 0;

        if (!(filterName === 'currentDialog' || filterName === 'inFile')) {
            if (!opened && !curFilters[filterName] === false) {
                return;
            }
        }

        if (filterName === 'syntaxErrors') {
            curFilters['syntaxErrors'] = true;
            curFilters['runtimeErrors'] = false;
            curFilters['info'] = false;
            curFilters[INPUT_PHRASES] = false;
            curFilters[OUTPUT_PHRASES] = false;
            curFilters[UNRECOGNIZED_PHRASES] = false;//entities
        } else if (filterName === 'currentDialog' || filterName === 'inFile') {
            curFilters[filterName] = !curFilters[filterName];
        } else if ([
            PHRASE_FILTER,
            PATTERN_FILTER,
            DIALOG_FILTER,
            PATTERNHASH_FILTER
        ].indexOf(filterName) > -1) {
            if (!curFilters[filterName]) {
                curFilters[filterName] = filterValue;
            } else {
                curFilters[filterName] = null;
            }
        } else if ([
            ENTITY_TYPE_FILTER,
            ENTITY_VALUE_FILTER
        ].indexOf(filterName) > -1) {
            const entityInd = _.findIndex(curFilters.entities, { [filterName]: filterValue });
            if (entityInd === -1) {
                curFilters.entities.push({ [filterName]: filterValue });
            } else {
                curFilters.entities.splice(entityInd, 1);
            }
        }
        else {
            curFilters['syntaxErrors'] = false;
            curFilters[filterName] = e ? !curFilters[filterName] : true;

            for (var i = 0; i < filters.length; i++) {
                if (curFilters[filters[i]] === true) {
                    activeFiltersCount++;
                }
            }

            if (activeFiltersCount === 0) {
                curFilters[filterName] = !curFilters[filterName];
            }
        }

        if (filterName === 'info' && curFilters[filterName]) {
            curFilters['runtimeErrors'] = true;
        }

        if (filterName === INPUT_PHRASES && curFilters[filterName]) {
            curFilters[UNRECOGNIZED_PHRASES] = true;
        }

        if (filterName === OUTPUT_PHRASES && curFilters[filterName]) {
            curFilters[INPUT_PHRASES] = true;
            curFilters[UNRECOGNIZED_PHRASES] = true;
        }

        this.setState({
            filters: curFilters,
            filterUpdateTs: Date.now(),

        }, () => {
            this.saveFiltersState();
        });

        if (!opened) {
            if (!(filterName === 'currentDialog' || filterName === 'inFile')) {
                (this.errorPanel as any).current?.resizer.current?.toggle(null);
            }
        }
        this.highlightLinesWithIcons();

        if (e) {
            if (curFilters.phraseLineNumber) {
                setTimeout(() => {
                    this.resetPhraseFilter();
                }, 0);
            }
            cancelEvent(e);
        }
    }

    setLineFilter = (filterName, filterValue) => {
        const curFilters = { ...this.state.filters };
        curFilters[filterName] = filterValue;
        this.setState({ filters: curFilters });
    }

    filterLogsForIcons() {
        const {
            syntaxErrors,
            logs,
            filters,
        } = this.state;

        const {
            script,
        } = this.props;

        const scriptName = script.name;
        let displayedLogs;

        displayedLogs = [...syntaxErrors, ...logs];

        displayedLogs = _.filter(displayedLogs, { file: scriptName });

        if (!filters.syntaxErrors) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.level !== logLevels.syntaxError;
            });
        }

        if (!filters.runtimeErrors) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.level !== logLevels.runTimeError;
            });
        }

        if (!filters.info) {
            displayedLogs = _.filter(displayedLogs, function (el) {
                return el.level !== logLevels.info;
            });
        }

        displayedLogs = _.filter(displayedLogs, function (el) {
            return !!el.line;
        });

        return displayedLogs;
    }

    getLogLines() {
        const displayedLogs = this.filterLogsForIcons();

        const linesLogs = {};

        for (let i = 0; i < displayedLogs.length; i++) {
            const curLog = displayedLogs[i];
            let str = '';
            if (curLog.level) {
                if (!linesLogs[curLog.line]) {
                    linesLogs[curLog.line] = [];
                }

                str = curLog.level + '';

                if (curLog.type) {
                    const phraseType = phraseTypes[curLog.type.toLowerCase()];
                    str += '_' + phraseType + (curLog.notFound ? '_notFound' : '') + (curLog.isWarning ? '_warning' : '');
                }
                if (curLog.isWarning) {
                    str += (curLog.isWarning ? '_warning' : '');
                }
                if (linesLogs[curLog.line].indexOf(str) === -1) {
                    linesLogs[curLog.line] = str;
                }
            }
        }
        return linesLogs;
    }

    highlightLinesWithIcons() {
        const linesLogs = this.getLogLines();

        const prevLogsHash = this.getLogsHash(this.prevHighlightedLogs);
        const logsHash = this.getLogsHash(linesLogs);

        if (prevLogsHash !== logsHash) {
            this.manageIconsInCm(linesLogs);
        }
        this.highlightGutterActionsIcons();
    }

    manageIconsInCm(linesLogs) {
        const logs = linesLogs;
        const lines = Object.keys(logs);

        if (lines.length > 0) {
            let scriptEditor = this.editor.current;
            if (scriptEditor && scriptEditor.editor) {
                scriptEditor = scriptEditor.editor;
                scriptEditor.operation(() => {
                    for (let i = 0; i < lines.length; i++) {
                        const curLine = lines[i];

                        const info = this.getLineInfoByStr(logs[curLine]);
                        let className = 'script-area-log';

                        if (info.level) {
                            className += ` script-area-log-level-${info.level}`;
                        }

                        // if (info.type) {
                        //     className += ` script-area-log-phrase-type-${info.type}`;
                        // }

                        // if (info.notFound) {
                        //     className += ` script-area-log-phrase-not-found`;
                        // }

                        if (info.warning) {
                            className += ` script-area-log-warning`;
                        }


                        scriptEditor.addLineClass(+curLine - 1, 'gutter', className);
                    }
                });

                this.prevHighlightedLogs = linesLogs;
            }
        } else {
            let scriptEditor = this.editor.current;
            scriptEditor = scriptEditor.editor;
            scriptEditor.operation(() => {
                scriptEditor.eachLine((cmLine) => {
                    if (cmLine.gutterClass) {
                        scriptEditor.removeLineClass(cmLine, 'gutter');
                        scriptEditor.removeLineClass(cmLine, 'wrap');
                    }
                });
                this.prevHighlightedLogs = linesLogs;
            });
        }
    }

    highlightGutterActionsIcons = () => {
        const { script } = this.props;
        const cm = this.getScriptEditorCm();
        if (cm) {
            cm.operation(() => {
                if (this.props.projectApis || this.props.alanBtnPopups || this.props.intents || this.props.transforms || this.props.corpuses) {
                    cm.eachLine((cmLine) => {
                        if (cmLine.gutterClass) {
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-run-project-api-call');
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-run-intent');
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-inspect-transform');
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-popup-editor');
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-inspect-corpus');
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-inspect-corpus-indexing');
                        }
                    });
                    if (this.props.projectApis) {
                        _.forEach(this.props.projectApis, (projectApiInfo: IProjectApiData) => {
                            cm.addLineClass(projectApiInfo.loc.start.line - 1, 'gutter', 'script-area-run-project-api-call');
                        });
                    }
                    if (this.props.intents && this.isSlu4_2()) {
                        _.forEach(this.props.intents, (intentInfo: IIntent) => {
                            cm.addLineClass(intentInfo.loc.start.line - 1, 'gutter', 'script-area-run-intent');
                        });
                    }
                    if (this.props.corpuses && this.isSlu4_2()) {
                        _.forEach(this.props.corpuses, (corpusApiInfo: ICorpusData) => {
                            cm.addLineClass(corpusApiInfo.loc.start.line - 1, 'gutter', 'script-area-inspect-corpus');
                            if (CorpusStatusKeeper.isIndexing(script.name, corpusApiInfo.loc.start.line)) {
                                cm.addLineClass(corpusApiInfo.loc.start.line - 1, 'gutter', 'script-area-inspect-corpus-indexing');
                            }
                        });
                    }
                    if (this.props.transforms) {
                        _.forEach(this.props.transforms, (transformInfo: IIntent) => {
                            cm.addLineClass(transformInfo.loc.start.line - 1, 'gutter', 'script-area-inspect-transform');
                        });
                    }
                    if (this.props.alanBtnPopups) {
                        _.forEach(this.props.alanBtnPopups, (popup: IAlanBtnPopup) => {
                            cm.addLineClass(popup.togglerPosition.line - 1, 'gutter', 'script-area-popup-editor');
                        });
                    }
                }
            });
        }
    }

    manageSelectedFilters(line, logInfo) {
        const info = this.getLineInfoByStr(logInfo);
        const currentHiddenFilters = this.state.hiddenFilters;

        if (+info.type === phraseTypes.input) {
            currentHiddenFilters.outputPhrases = true;
            this.setFilter(INPUT_PHRASES, null);
        }
        if (+info.type === phraseTypes.output) {
            this.setFilter(OUTPUT_PHRASES, null);
            currentHiddenFilters.inputPhrases = true;
            currentHiddenFilters.unrecognizedPhrases = true;
        }

        this.setState({ hiddenFilters: currentHiddenFilters });
    }

    getLogsHash(logs) {
        let hash = '';

        if (logs === null) {
            return null;
        }

        if (_.isObject(logs) && _.isEmpty(logs)) {
            return hash;
        }

        const keys = Object.keys(logs);

        for (var i = 0; i < keys.length; i++) {
            hash += keys[i] + ':' + logs[keys[i]] + ';';
        }
        return hash;
    }


    getLineInfoByStr(str): ILineInfo {
        const lineInfo = str.split('_');
        const res = {} as ILineInfo;

        res.level = lineInfo[0];

        if (lineInfo[1]) {
            res.type = lineInfo[1];
        }
        if (lineInfo[2]) {
            res.notFound = lineInfo[2];
        }

        if (str.indexOf('warning') > -1) {
            res.warning = true;
        }

        return res;
    }

    setFilterLineNumberInCm = (lineNumber) => {
        let scriptEditor = this.editor.current;

        if (scriptEditor && scriptEditor.editor) {
            scriptEditor = scriptEditor.editor;
            const line = this.getCmLine(lineNumber);
            scriptEditor.operation(() => {
                scriptEditor.eachLine((cmLine) => {
                    if (cmLine.gutterClass) {
                        scriptEditor.removeLineClass(cmLine, 'gutter', 'script-area-phrase-line');
                    }
                });

                scriptEditor.addLineClass(line, 'gutter', 'script-area-phrase-line');
            });
        }
    }

    resetFilterLineNumberInCm = () => {
        let scriptEditor = this.editor.current;

        if (scriptEditor && scriptEditor.editor) {
            scriptEditor = scriptEditor.editor;

            scriptEditor.operation(() => {
                scriptEditor.eachLine((cmLine) => {
                    if (cmLine.gutterClass) {
                        scriptEditor.removeLineClass(cmLine, 'gutter', 'script-area-phrase-line');
                    }
                });
            });
        }
    }

    setPatternFilter = (filter, hash) => {
        const { filters } = this.state;
        this.setState({
            filters: {
                ...filters,
                [PATTERNHASH_FILTER]: hash,
                [PATTERN_FILTER]: filter
            }
        }, () => {
            this.updateFiltersStatesAfterResset();
        });
    }

    resetPatternFilter = () => {
        const { filters } = this.state;
        this.setState({
            filters: {
                ...filters,
                [PATTERNHASH_FILTER]: null,
                [PATTERN_FILTER]: null,
                lastTs: null
            }
        }, () => {
            this.updateFiltersStatesAfterResset();
        });
    }

    resetPhraseTextFilter = () => {
        const { filters } = this.state;
        this.setState({
            filters: {
                ...filters,
                [PHRASE_FILTER]: null,
                lastTs: null
            },
        }, () => {
            this.updateFiltersStatesAfterResset();
        });
    }

    resetEntityFilter = (entity) => {
        const { filters } = this.state;
        const entities = [...filters.entities];
        const entityInd = _.findIndex(entities, entity);
        entities.splice(entityInd, 1);

        this.setState({
            filters: {
                ...filters,
                entities,
                lastTs: null
            }
        }, () => {
            this.updateFiltersStatesAfterResset();
        });

    }

    resetDialogFilter = () => {
        const { filters } = this.state;

        this.setState({
            filters: {
                ...filters,
                [DIALOG_FILTER]: null,
                lastTs: null
            }
        }, () => {
            this.updateFiltersStatesAfterResset();
        });
    }

    resetAllPhrasesFilters = () => {
        const { filters } = this.state;
        this.resetDialogFilter();

        this.setState({
            filters: {
                ...filters,
                [PATTERNHASH_FILTER]: null,
                [PATTERN_FILTER]: null,
                [PHRASE_FILTER]: null,
                [DIALOG_FILTER]: null,
                entities: [],
                lastTs: null
            }
        }, () => {
            this.updateFiltersStatesAfterResset();
        });
    }

    updateFiltersStatesAfterResset = () => {
        const { filters } = this.state;
        this.setState({
            filters,
            filterUpdateTs: Date.now()
        }, () => {
            this.saveFiltersState();
        });
    }

    getCmLine(strLine) {
        return +strLine - 1;
    }

    resetPhraseFilter = (e?: React.MouseEvent) => {
        this.setState({
            filters: {
                ...this.state.filters,
                phraseLineNumber: null,
                lastTs: null,
            },
            hiddenFilters: {} as ILogFilters
        }, () => {
            this.updateFiltersStatesAfterResset();
            this.resetFilterLineNumberInCm();
        });

        if (e) {
            cancelEvent(e);
        }
    }

    async checkForErrors(project, afterChange) {
        const scriptsForChecking = [];
        let continueChecking;
        const { script } = this.props;

        if (afterChange === true) {
            continueChecking = true;
        }

        if ((!continueChecking && this.checkedScripts[script.scriptId]) || this.state.scriptIsUpdating) {
            return;
        }

        if (project && project.scripts) {
            const textScripts = project.scripts.filter(s => s.type !== 'transform');
            for (let i = 0; i < textScripts.length; i++) {
                const currentScript = textScripts[i];

                const hasDraft = await scriptDraftsService.hasDraft(currentScript.scriptId);
                let scriptDraft = currentScript.text;

                if (hasDraft) {
                    scriptDraft = await scriptDraftsService.getScriptText(currentScript);
                }

                scriptsForChecking.push({
                    name: currentScript.name,
                    text: scriptDraft
                } as IScript);

                this.checkedScripts[currentScript.scriptId] = Date.now();
            }
            if (scriptsForChecking.length && !this.props.transformMode) {
                this.props.checkErrors({
                    project,
                    scripts: scriptsForChecking.filter(script => !(((script.script && script.script.length) || 0) > CHARACTER_LIMIT))
                });
            }
        }
    }

    delayedCheckForErrors = _.debounce(this.checkForErrors, 1000);

    checkForLinesChanges = (value) => {
        const { script, hasScripts } = this.props;
        if (hasScripts) {
            const scriptEditor = this.getScriptEditorCm();
            if (!scriptEditor) return;
            this._changesWorker.postMessage({
                msg: 'createDiff',
                options: {
                    script: {
                        initialText: script.text,
                        newText: value,
                        name: script.name,
                    },
                    includeLineInfo: true
                }
            });
        }
    }

    updateErrors = (errors, cb) => {
        errors = errors || [];

        const logsUpdatedTs = Date.now();

        for (var i = 0; i < errors.length; i++) {
            errors[i].level = logLevels.syntaxError;
            errors[i].ts = Date.now();
        }

        if (errors && errors.length) {
            this.setState({ syntaxErrors: errors, logsUpdatedTs: logsUpdatedTs }, cb);
        } else {
            if (this.state.syntaxErrors.length !== 0) {
                this.setState({ syntaxErrors: [], logsUpdatedTs: logsUpdatedTs }, cb);
            }
        }
    }

    updateCode = (text) => {
        const { script, updateScriptTextInEditor, environment } = this.props;
        if (environment === Environment.Staging) {
            updateScriptTextInEditor({ script, newScriptText: text });
        }
        this.setState({ scriptTextCurrent: text }, () => {
            this.updateSearch();
        });
        if (!this.isFileTooLarge(text)) {
            this.props.onCodeChange({ codeString: text, fileName: this.props.script?.name });
        }
    };

    onSaveHotKeyCb = async (event) => {
        const {
            script,
            project,
            environment,
        } = this.props;

        const {
            selectedPopupEditorKey
        } = this.state;

        const keyCode = event.keyCode || event.which;

        if (selectedPopupEditorKey) return;

        if (keyCode === 83 && (event.ctrlKey || event.metaKey)) {
            cancelEvent(event);

            const isLastTag = projectHelper.isLastTag(project, this.props[`selected${capitalize(environment)}TagId`]);
            const hasUnsavedChanges = await projectHelper.hasUnsavedChanges(project);
            const isSaveBtnDisabled = !(isLastTag && hasUnsavedChanges);

            if (isSaveBtnDisabled) {
                return;
            }

            if (environment !== Environment.Staging) {
                return;
            }

            if (this.isScriptSaving) {
                return;
            }
            this.isScriptSaving = true;
            saveAllClick();
        }
    }

    clearUnsavedScriptMarkers = (e) => {
        if (e && e.type === 'clearUnsavedScriptMarkers') {
            const { scriptText } = this.state;
            const { script } = this.props;
            this.sendSavedTextToCodeMirror(scriptText, script, false);
        }
    }

    openErrorsInErrorPanel = (e: IOpenErrorsEvent) => {
        this.setFilter(e.detail.filterName);
    }

    getScriptKey(noUpdateTs) {
        const {
            script,
            tagId,
            projectMode,
            project
        } = this.props;
        return `${script.scriptId}-${tagId}-${projectMode}` + (noUpdateTs ? '' : `-${project.updateTs}`);
    }

    rememberCmScrollPosition = (editor, data) => {
        const scriptKey = this.getScriptKey(true);
        if (isLocalStorageAvailable()) {
            localStorage.setItem(`${scriptKey}${scrollTopPosTrail}`, data.top);
            localStorage.setItem(`${scriptKey}${scrollLeftPosTrail}`, data.left);
        }
    }

    delayedRememberCmScrollPosition = _.debounce(this.rememberCmScrollPosition, 300);

    rememberCmCursorPosition = (editor, data) => {
        const scriptKey = this.getScriptKey(true);
        if (isLocalStorageAvailable()) {
            localStorage.setItem(`${scriptKey}${cursorLineTrail}`, data.line);
            localStorage.setItem(`${scriptKey}${cursorChTrail}`, data.ch);
        }
    }

    closeDefinitionNavTooltip = () => {
        this.setState({ showDefinitionNav: false });
        ReactTooltip.hide(document.getElementById(tooltips.definitionNav));
        saveTooltipState(tooltips.definitionNav);
    };

    setCursor = _.debounce((cursor) => {
        this.setState({
            cursor,
        });
    }, 300);

    onResize = () => {
        const scriptEditor = this.getScriptEditorCm();
        if (!scriptEditor) return;
        scriptEditor.refresh();
    };

    removeAutoFillIcon = () => {
        if (this.state.autoFillFunctionInfo?.lineNumber >= 0) {
            const cm = this.getScriptEditorCm();
            if (cm) {
                cm.operation(() => {
                    cm.removeLineClass(this.state.autoFillFunctionInfo?.lineNumber, 'gutter', 'script-area-fn-autofill');
                    this.setState({ autoFillFunctionInfo: null });
                });
            }
        }
    }

    onBlur = () => {
        this.removeAutoFillIcon();
    };

    onCursor = (editor, data) => {
        this.cursor = data;
        this.onCursorChange(editor, data);
        this.removeAutoFillIcon();
    };

    onCursorChange = _.throttle((editor, data) => {
        const { bracketsInStringsToHighlight, currentBrackets, currentMemberHighlights } = setCurrentBrackets(this.cursor, this.getStringLines(), this.props.brackets, this.props.membersMap);
        this.setState({
            bracketsInStringsToHighlight,
            currentBrackets,
            currentMemberHighlights,
        });
        this.setCursor(data);
        this.rememberCmCursorPosition(editor, data);
        this.manageAutoFillIcon(editor, data);
    }, 150);

    onKeyDown = _.debounce((editor, e) => {
        if ((e.keyCode >= 65 && e.keyCode <= 90 && !e.metaKey && !e.ctrlKey && !e.altKey) ||
            (e.shiftKey && e.keyCode === 189) ||
            (e.keyCode === 190)) {
            editor.showHint();
        }
    }, 250);

    onPaste = (editor, e) => {
        const copiedText = (e.originalEvent || e).clipboardData.getData('text/plain');
        if (getStrLengthInUtf8Bytes(copiedText) > SCRIPT_SIZE_LIMIT) {
            ToasterService.showWarning({ title: 'Script is too big, it cannot be added' });
            e.preventDefault();
        }
    };

    onChange = _.debounce((editor, data, value, e) => {
        const { isScriptSaving } = store.getState().projectsInfo.currentProject;
        if (value === '' || value) {
            this.checkForLinesChanges(value);
            if (!isScriptSaving) {
                this.updateCode(value);
                this.checkedScripts[this.props.script.scriptId] = null;
                this.delayedCheckForErrors(this.props.project, true);
                const { bracketsInStringsToHighlight, currentBrackets, currentMemberHighlights } = setCurrentBrackets(this.cursor, this.getStringLines(), this.props.brackets, this.props.membersMap);
                this.setState({
                    bracketsInStringsToHighlight,
                    currentBrackets,
                    currentMemberHighlights,
                });
            }
        }
    }, 100);

    onFocus = () => {
        window.dispatchEvent(new CustomEvent('codeAreaGotFocus'));
    };

    onScroll = (editor, data) => {
        this.delayedRememberCmScrollPosition(editor, data);
    };

    isSlu4_2 = () => {
        return projectHelper.isSlu4_2(this.props.project);
    }

    manageAutoFillIcon = _.debounce((editor, data) => {
        const line = data.line + 1;
        if (this.props.projectApis) {
            const projectApiKeys = Object.keys(this.props.projectApis);
            const cm = editor;
            if (cm) {
                cm.operation(() => {
                    cm.eachLine((cmLine) => {
                        cm.removeLineClass(cmLine, 'gutter', 'script-area-fn-autofill');
                    });
                });
            }
            for (let i = 0; i < projectApiKeys.length; i++) {

                if (this.props.projectApis[projectApiKeys[i]].type === 'function' &&
                    this.props.projectApis[projectApiKeys[i]].loc.start.line < line &&
                    this.props.projectApis[projectApiKeys[i]].loc.end.line > line) {

                    if (this.props.transforms[line] ||
                        this.props.corpuses[line] ||
                        this.props.projectApis[line] ||
                        Object.entries(this.props.alanBtnPopups).map(el => el[1]).some(el => el?.togglerPosition?.line === line)
                    ) {
                        return;
                    }

                    const cmLine = line - 1;
                    this.setState({
                        autoFillFunctionInfo: {
                            lineNumber: cmLine,
                            end: this.props.projectApis[projectApiKeys[i]].loc.end
                        }
                    });
                    if (cm) {
                        cm.addLineClass(cmLine, 'gutter', 'script-area-fn-autofill');
                    }
                    return;
                }
            }
            this.setState({ autoFillFunctionInfo: null });
        }
    }, 500)

    onGutterClick = (editor, lineNumber) => {
        const logLines = this.getLogLines();
        const line = +lineNumber + 1;
        const filters = this.state.filters;
        const { intents, sendIntent, transforms, project, corpuses, scriptName, script } = this.props;
        const { autoFillFunctionInfo } = this.state;


        if (this.props.alanBtnPopups) {
            const popupKeys = Object.keys(this.props.alanBtnPopups);
            let selectedPopupEditorKey = null;
            for (let i = 0; i < popupKeys.length; i++) {
                if (this.props.alanBtnPopups[popupKeys[i]].togglerPosition.line === line) {
                    selectedPopupEditorKey = popupKeys[i];
                    this.setState({ selectedPopupEditorKey });
                    return;
                }
            }

        }

        if (this.props.projectApis) {
            const projectApiKeys = Object.keys(this.props.projectApis);
            let selectedProjectApi = null;
            for (let i = 0; i < projectApiKeys.length; i++) {
                if (this.props.projectApis[projectApiKeys[i]].loc.start.line === line) {
                    selectedProjectApi = projectApiKeys[i];
                    this.setState({ selectedProjectApi });
                    return;
                }
            }
        }


        if (transforms) {
            const transformKeys = Object.keys(transforms);
            let selectedTransform = null;
            for (let i = 0; i < transformKeys.length; i++) {
                if (transforms[transformKeys[i]].loc.start.line === line) {
                    selectedTransform = transformKeys[i];
                    this.setState({ selectedTransform: transforms[selectedTransform]?.name });
                    return;
                }
            }
        }

        if (corpuses && this.isSlu4_2()) {
            const corpusesKeys = Object.keys(corpuses);
            for (let i = 0; i < corpusesKeys.length; i++) {
                if (corpuses[corpusesKeys[i]].loc.start.line === line) {
                    routeHistory.push(routeInfo.corpuses.url(project.name, scriptName, line));
                    return;
                }
            }
        }


        if (intents && this.isSlu4_2()) {
            const intentsKeys = Object.keys(intents);
            for (let i = 0; i < intentsKeys.length; i++) {
                if (intents[intentsKeys[i]].loc.start.line === line) {
                    const cm = this.getScriptEditorCm();
                    const cmLine = line - 1;
                    if (cm && !this.state.intentIsRunning) {
                        this.setState({ intentIsRunning: true });
                        cm.addLineClass(cmLine, 'gutter', 'script-area-alan-refresh');
                        const timeoutId = setTimeout(() => {
                            if (cm) {
                                cm.removeLineClass(cmLine, 'gutter', 'script-area-alan-refresh');
                                this.setState({ intentIsRunning: false });
                            }
                        }, 5000);
                        sendIntent({ text: intents[intentsKeys[i]].value }).finally(() => {
                            cm.removeLineClass(cmLine, 'gutter', 'script-area-alan-refresh');
                            clearTimeout(timeoutId);
                            this.setState({ intentIsRunning: false });
                        }).catch(err => { });
                    }
                    return;
                }
            }
        }
        if (autoFillFunctionInfo?.lineNumber === lineNumber) {
            this.setState({ scriptIsUpdating: true }, async () => {
                const scriptText = await scriptDraftsService.getScriptText(script) || script.text;
                this.props.runCodeGenerator({
                    script: scriptText,
                    line: this.cursor?.line,
                    column: this.cursor?.ch
                }).then((streamId: string) => {
                    if (autoFillFunctionInfo?.end !== undefined) {
                        const savedCursor = { ...this.cursor };
                        var start = { line: this.cursor.line, ch: this.cursor.ch };
                        var lastFnLine = autoFillFunctionInfo.end?.line - 1;
                        if (lastFnLine > -1) {
                            const cm = this.getScriptEditorCm();
                            if (cm) {
                                var lineAboveLast = cm.getLine(lastFnLine);
                                var end = { line: lastFnLine, ch: lineAboveLast.length };
                                cm.replaceRange('', start, end);
                                cm.setCursor(savedCursor);
                            }

                        }
                    }
                    this.setState({ codeGeneratorStreamId: streamId });
                }).catch(() => {
                    ToasterService.showError({ title: messages.scriptGeneratorErr });
                    this.setState({ codeGeneratorStreamId: null, scriptIsUpdating: false });
                });
            });

            return;
        }

        if (filters.phraseLineNumber === line) {
            this.resetPhraseFilter();
        } else {
            if (logLines[line]) {
                this.resetPhraseFilter();
                this.setLineFilter('phraseLineNumber', line);
                this.setFilterLineNumberInCm(line);
                this.manageSelectedFilters(line, logLines[line]);
                if (!(this.errorPanel as any).current?.resizer.current?.state.isOpened) {
                    (this.errorPanel as any).current?.resizer.current?.open(null);
                }
            }
        }
    };

    isFileTooLarge = (scriptText) => {
        const { script, openedLargeFiles } = this.props;

        if (openedLargeFiles[script?.scriptId]) {
            return false;
        }

        return ((scriptText && scriptText.length) || 0) > CHARACTER_LIMIT;
    }

    openLargeScript = () => {
        this.props.openLargeScript({
            scriptId: this.props.script?.scriptId
        });
    }

    render() {
        const {
            script,
            tagId,
            project,
            environment,
            hasScripts,
            scriptName,
            activePatterns,
            activePatternsUpdateTs,
            projectName,
            fontSize,
            codeTheme,
            searchTerm,
            showSearch,
            githubDeployId,
            transformMode,
            projectApis
        } = this.props;

        const {
            errorPanelTransitionInProcess,
            logsUpdatedTs,
            filterUpdateTs,
            logs,
            syntaxErrors,
            filters,
            hiddenFilters,
            highlightingType,
            scriptText,
            scriptTextCurrent,
            hasLoadedLogs,
            selectedPopupEditorKey,
            selectedProjectApi,
            selectedTransform,
            scriptIsUpdating,
        } = this.state;

        const hasFilterByPhrases = this.hasFilterByPhrases();

        let classes = `script-container ${transformMode ? '' : environment}`;
        let scriptAreaClasses = `script-area font-${fontSize} ${codeTheme}`;

        if (!(project && project.projectId)) {
            classes += ' disabled';
        }

        const isLastTag = projectHelper.isLastTag(project, tagId);

        let options = CODE_MIRROR_OPTIONS;

        const isFileTooLarge = this.isFileTooLarge(scriptText);
        const isCiCd = githubDeployId !== '';
        const isEditable = !(!isLastTag || (environment !== Environment.Staging) || isFileTooLarge || isCiCd || scriptIsUpdating);

        if (!isEditable) {
            options = CODE_MIRROR_OPTIONS_READ_ONLY;
            scriptAreaClasses += ' read-only-mode';
        }

        if (scriptIsUpdating) {
            scriptAreaClasses += ' code-generation';
        }

        const scriptTextToShow = isFileTooLarge ? scriptText.slice(0, TEXT_TO_SHOW_LENGTH) : scriptText;

        if (isFileTooLarge) {
            options = {
                ...options,
                lineWrapping: true,
            };
        }

        if (highlightingType) {
            scriptAreaClasses += ` highlighted-${highlightingType}`;
        }

        let scriptExist = true;
        if (hasScripts && scriptName) {
            scriptExist = !!_.find(project.scripts, { name: scriptName });
        }

        return (
            <div className={classes}>
                <div className={`script-container_scripts-and-script-editor-row ${hasScripts && 'has-scripts'}`}>
                    <ScriptsPanelContainer
                        environment={environment}
                        projectName={projectName}
                        scriptName={scriptName}
                        searchTerm={searchTerm}
                        onPanelCollapsed={() => {
                            this.setState({ isScriptsPanelCollapsed: true });
                        }}
                        onPanelExpanded={() => {
                            this.setState({ isScriptsPanelCollapsed: false });
                        }}
                        onCloseSearch={this.closeSearch}
                    />
                    {!transformMode && <>
                        {(!hasScripts && !project.scriptsLoading) &&
                            <NoScriptsView
                                environment={environment}
                            />}

                        <div className={`${scriptAreaClasses} ${hasScripts && 'has-scripts'} ${showSearch && 'with-search'}`} ref={this.container}>
                            {scriptExist ?
                                <React.Fragment>
                                    {scriptName ?
                                        (script.error ?
                                            <ScriptIsUnavailableView
                                                environment={environment}
                                                scriptName={scriptName} /> :
                                            <React.Fragment>
                                                <EditorSearch searchKey={SCRIPT_EDITOR} getScriptEditorCm={this.getScriptEditorCm}
                                                    allowReplace={isEditable} />
                                                <div className="script-wrapper">
                                                    {this.state.showDefinitionNav && <TileTooltip tooltipId={tooltips.definitionNav}
                                                        tooltipPlace="right"
                                                        tooltipClass="definition-nav-tooltip">
                                                        <div>Use <b>Shift</b> + <b>Backspace</b><br />
                                                            to navigate back in your code editor<br />
                                                        </div>
                                                        <div className="alan-tooltip-got-it"
                                                            onClick={this.closeDefinitionNavTooltip}>Got It
                                                        </div>
                                                    </TileTooltip>}
                                                    {(scriptText || scriptText === '') &&
                                                        <ReactCodeMirror
                                                            ref={this.editor}
                                                            className={`with-gutter ${isFileTooLarge && 'large-file'}`}
                                                            value={scriptTextToShow || ''}
                                                            options={options}
                                                            onCursor={this.onCursor}
                                                            onPaste={this.onPaste}
                                                            onBlur={this.onBlur}
                                                            onChange={this.onChange}
                                                            onKeyDown={this.onKeyDown}
                                                            onFocus={this.onFocus}
                                                            onScroll={this.onScroll}
                                                            onGutterClick={this.onGutterClick}
                                                        />
                                                    }
                                                    {/* {((scriptText && scriptText.length) || 0) <= CHARACTER_LIMIT &&
                                                        <FlowDiagram
                                                            code={scriptTextCurrent || ''}
                                                            environment={environment}
                                                            parentCont={this.container.current}
                                                            cursor={this.state.cursor}
                                                            highlightLine={this.highlightLine}
                                                            project={this.props.project}
                                                            onIntentClick={this.scrollToLine}
                                                            activePatterns={activePatterns}
                                                            scriptName={script.name}
                                                            getScriptEditorCm={this.getScriptEditorCm}
                                                            activePatternsUpdateTs={activePatternsUpdateTs} />
                                                    } */}
                                                    {scriptIsUpdating &&
                                                        <div
                                                            className="action-btn light-blue-with-border big script-wrapper__cancel-autofill-btn"
                                                            onClick={this.stopCodeGeneration}>
                                                            <i className="icon icon-alan-circle-inactive" />
                                                            Stop Code Generation
                                                        </div>}
                                                </div>
                                            </React.Fragment>)
                                        :
                                        (project.addingScriptsIsInprocess &&
                                            <Loader theme={LoaderTheme.Dark} size={LoaderSize.Medium} center={true} />)}
                                </React.Fragment> :
                                <NoExistingScriptView
                                    environment={environment}
                                    scriptName={scriptName} />}
                            <div className={`script-wrapper__notification ${isFileTooLarge && 'script-wrapper__notification_visible'}`}>
                                <div className="script-wrapper__notification__text-content">
                                    <img src={warningSign} />
                                    <div className="script-wrapper__notification__text">{messages.scriptTooLarge}</div>
                                </div>
                                <a onClick={this.openLargeScript}>Open full version.</a>
                            </div>
                        </div>
                    </>}

                    {transformMode && <>
                        {project.scriptsLoading ?
                            '' :
                            <TransformContainer
                                scriptName={scriptName}
                                environment={environment}
                                isScriptsPanelCollapsed={this.state.isScriptsPanelCollapsed}
                                script={script}
                                project={project}
                                discardScriptsChangesTs={this.props.discardScriptsChangesTs}
                            />}
                    </>
                    }
                </div>

                {!transformMode && <>
                    {selectedPopupEditorKey && <AlanButtonPopupsEditor
                        project={project}
                        environment={environment}
                        script={script}
                        selectedKey={selectedPopupEditorKey}
                        onSave={this.onAlanBtnPopupsDataSaved}
                        onClose={this.closePopupEditor}
                    />}

                    {selectedProjectApi && <CallProjectApiPanel
                        projectId={project.projectId}
                        environment={environment}
                        selectedProjectApi={selectedProjectApi}
                        isOpened={!!selectedProjectApi}
                        onSelectProjectApi={this.selectProjectApi}
                        onClose={this.closeProjectApiRunner}
                        mode={'run-fn'}
                        historyKey={projectApis[selectedProjectApi]?.type === 'projectAPI' ? "CallProjectApiHistory" : "CallFunctionHistory"}
                    />}
                    {selectedTransform && <InspectTransformPanel
                        environment={environment}
                        project={project}
                        transformName={selectedTransform}
                        key={selectedTransform}
                        onClose={this.closeTransformInspector}
                    />}
                </>}


                {(hasScripts && !transformMode) && <ErrorPanel
                    ref={this.errorPanel}
                    onResize={this.onResize}
                    parentCont={this.container.current}
                    syntaxErrors={syntaxErrors}
                    logs={logs}
                    logsUpdatedTs={logsUpdatedTs}
                    filterUpdateTs={filterUpdateTs}
                    filters={filters}
                    hasLoadedLogs={hasLoadedLogs}
                    hiddenFilters={hiddenFilters}
                    clearLogsCb={this.clearLogs}
                    setFilterCb={this.setFilter}
                    openingInProcess={errorPanelTransitionInProcess}
                    environment={environment}
                    script={script}
                    project={project}
                    scriptsHash={project.scriptsHash}
                    exportingLogs={project.exportingLogs}
                    exportingDialogs={project.exportingDialogs}
                    highlightLine={this.highlightLine}
                    resetPhraseFilterCb={this.resetPhraseFilter}
                    hasFilterByPhrases={hasFilterByPhrases}
                    resetAllPhrasesFilters={this.resetAllPhrasesFilters}
                    setPatternFilter={this.setPatternFilter}
                    resetPatternFilter={this.resetPatternFilter}
                    resetPhraseTextFilter={this.resetPhraseTextFilter}
                    resetEntityFilter={this.resetEntityFilter}
                    resetDialogFilter={this.resetDialogFilter}
                />}
            </div>
        );
    }
}



function mapStateToProps({ scriptEditor, user, codeMetaData, projectsInfo, gitHubIntegration }: IStore) {
    return {
        highlightedLine: scriptEditor.highlightedLine,
        highlightedLineType: scriptEditor.highlightedLineType,
        highlightedLineOffset: scriptEditor.highlightedLineOffset,
        highlightedDefinitionName: scriptEditor.highlightedDefinitionName,
        activePatternsUpdateTs: projectsInfo.currentProject.activePatternsUpdateTs,
        activePatterns: projectsInfo.currentProject.activePatterns,
        openedLargeFiles: projectsInfo.currentProject.openedLargeFiles,
        fontSize: scriptEditor.fontSize,
        codeTheme: scriptEditor.codeTheme,
        isParsingInProcess: codeMetaData.isParsingInProcess,
        declarationIndex: codeMetaData.declarationIndex,
        alanBtnPopups: codeMetaData.alanBtnPopups,
        projectApis: codeMetaData.projectApis,
        corpuses: codeMetaData.corpuses,
        transforms: codeMetaData.transforms,
        intents: codeMetaData.intents,
        membersMap: codeMetaData.membersMap,
        imports: codeMetaData.imports,
        syntaxErrors: codeMetaData.syntaxErrors,
        invalidBrackets: codeMetaData.invalidBrackets,
        brackets: codeMetaData.brackets,
        bracketsInStrings: codeMetaData.bracketsInStrings,
        strings: codeMetaData.strings,
        playStrings: codeMetaData.playStrings,
        patternStrings: codeMetaData.patternStrings,
        showSearch: scriptEditor.searchPanels[SCRIPT_EDITOR]?.showSearch,
        showReplace: scriptEditor.searchPanels[SCRIPT_EDITOR]?.showReplace,
        searchTerm: scriptEditor.searchPanels[SCRIPT_EDITOR]?.searchTerm,
        email: user.email,
        githubDeployId: gitHubIntegration.githubDeployId,
        discardScriptsChangesTs: projectsInfo.currentProject.discardScriptsChangesTs,
    };
}


function mapDispatchToProps(dispatch) {

    return {
        updateScripts: (param) => dispatch(updateScripts(param)),
        openLargeScript: (param: IOpenLargeScriptParam) => dispatch(projectActions.openLargeScript(param)),
        updateScriptTextInEditor: (param) => dispatch(scriptEditorActions.updateScriptTextInEditor(param)),
        onCodeChange(param) {
            asyncDispatch(actions.parseCode, dispatch, param);
        },
        checkErrors(param) {
            asyncDispatch(actions.checkErrors, dispatch, param);
        },
        sendIntent(param: ISendIntentParam) {
            return asyncDispatch(projectActions.sendIntent, dispatch, param);
        },
        runCodeGenerator(param: projectActions.IRunCodeGeneratorParam) {
            return asyncDispatch(projectActions.runCodeGenerator, dispatch, param);
        },
        resetCodeData() {
            dispatch(actions.reset());
        },
        resetHighlighting: () => dispatch(scriptEditorActions.resetHighlighting()),
        highlightLine: (param: IHighlightLineParams) => dispatch(scriptEditorActions.highlightLine(param)),
        updateUnloadPageListenerForProject: (param) => asyncDispatch(unloadPageActions.updateUnloadPageListenerForProject, dispatch, param),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ScriptArea);